<template lang="pug">
    div
        select.form-control(v-model="modelValue", required)
            option(value="" disabled) --- Please select a person ---
            option(v-if="loaded && filteredPeople.length === 0" value="" disabled) --- No people for this biobank ---
            option(v-for="person in filteredPeople", :key="person.id", :value="person.id")
                | {{person.first_name}} {{person.last_name}} &lt;{{person.email}}&gt;
</template>

<script>
import {getPeople} from "../api";
import {filteredPeople} from "./common";

export default {
    props: {
        value: null,
        biobank: {
            type: String,
            default: ""
        },
        warnIfEmpty: {
            type: Boolean,
            default: false
        },
        statusKey: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            people: [],
            loaded: false
        };
    },
    created() {
        this.loadPeople();
    },
    methods: {
        loadPeople() {
            this.loaded = false;
            getPeople(this.biobank ? {biobank: this.biobank} : {})
            .then(people => {
                this.people = people;
                this.loaded = true;
                this.$emit("people-status", {key: this.statusKey, empty: people.length === 0});
            })
            .catch(() => {
                this.people = [];
                this.loaded = true;
                this.$emit("people-status", {key: this.statusKey, empty: true});
            });
        },
    },
    watch: {
        biobank() {
            this.loadPeople();
        }
    },
    computed: {
        filteredPeople,
        modelValue: {
            get() {
                return this.value || "";
            },
            set(value) {
                this.$emit("input", value || null);
            }
        }
    }
}
</script>
